<template>
  <CockpitDialog class="cameraPicture" title="作业态势感知" @close="close">
    <div class="w-full h-6/7 flex justify-center items-center flex-col" v-loading="loading">
      <div
        class="w-6/7 h-1/2 flex justify-center items-center mb-10px flex-wrap"
        v-for="(flag, index) in 2"
        :key="'flag' + index"
      >
        <div
          class="w-[calc(50%-10px)] h-full mx-5px"
          v-for="(item, index) in deviceList.slice(0 + (flag - 1) * 2, 2 + (flag - 1) * 2)"
          :key="index"
        >
          <YSPlayer :code="item.code" :pIid="item.pIid" class="w-full h-full"></YSPlayer>
        </div>
      </div>
    </div>
    <el-pagination
      v-loading="loading"
      background
      :current-page.sync="pagePart.pageNo"
      :page-size.sync="pagePart.pageSize"
      @current-change="getCameraList"
      layout="slot, prev, pager, next"
      :total="pagePart.total"
      class="text-center mt-20px"
    >
      <template>
        <span class="text-white-60 ">共</span>
        <span class="text-[#FBAF3D]">{{ Math.ceil(pagePart.total / 4.0) }}</span>
        <span class="text-white-60  mr-10px">页</span>
      </template>
    </el-pagination>
  </CockpitDialog>
</template>

<script>
// apis
import { IOTDeviceApi } from '@wiz-api/iot-device-management'

//
const iotDeviceApi = new IOTDeviceApi()

// components
const CockpitDialog = () => {
  return import('@/components/cockpit/CockpitDialog')
}
const YSPlayer = () => {
  return import('../components/video/YSPlayer/YSPlayer')
}
export default {
  name: 'SecuritySituationalAwareness',
  components: {
    CockpitDialog,
    YSPlayer,
  },
  data() {
    return {
      loading: false,
      pagePart: {
        total: 0,
        pageNo: 1,
        pageSize: 4,
      },
      deviceList: [],
    }
  },
  created() {
    this.getCameraList()
  },
  methods: {
    close() {
      this.$emit('refresh', false)
    },
    async getCameraList() {
      this.loading = true
      const [err, res] = await iotDeviceApi.getDeviceWithDetailPageList({
        skipCount: this.pagePart.pageNo,
        maxResultCount: 4,
      })
      if (res && !err) {
        this.deviceList = res.items
        this.pagePart.total = res.totalCount
      }
      this.loading = false
    },
  },
}
</script>
<style lang="scss" scoped>
.cameraPicture {
  left: 520px;
  top: 200px;
}
.text-white-60 {
  color: white;
  opacity: 0.6;
}
</style>
